// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18u019bv{margin-left:10px}\n._2hwx19bv{margin-right:10px}", ""]);
// Exports
module.exports = exports;
